// Third-party libraries
import 'reflect-metadata';

// Angular
import {registerLocaleData} from '@angular/common';
import localeFa from '@angular/common/locales/fa';
import {enableProdMode} from '@angular/core';
import {bootstrapApplication} from '@angular/platform-browser';
import {provideRouter, withComponentInputBinding, withInMemoryScrolling} from '@angular/router';

// App components
import {AppComponent} from '@app/app.component';

// App routes
import {routes} from '@app/app.routes';

// App providers
import {coreProviders} from '@app/core/core.providers';

// App environment
import {environment} from '@env/environment';

registerLocaleData(localeFa, 'fa-IR');

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      }),
    ),
    ...coreProviders,
  ],
}).catch(err => console.error(err));
